import React, { useState, useEffect, useCallback } from "react";
import Home from "../pages/home";
import Product from "../pages/home/product";
import Basket from "../pages/home/basket";
import Checkout from "../pages/checkout";
import Orders from "../pages/orders";
import Settings from "../pages/settings";
import Register from "../pages/auth/register";
import Login from "../pages/auth/login";
import Reset from "../pages/auth/reset";
import DataContext from "../contexts/data";
import CartContext from "../contexts/cart";
import Terms from "../pages/terms";
import Fire from "../api/Fire";
import { Route } from "react-router";
import { Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import RightSideBar from "../components/RightSideBar";
import LeftSideBar from "../components/LeftSideBar";
import Dialog from "../components/Dialog";
import { useTranslation } from "react-i18next";

const Routes = () => {
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState(1);
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [prodType, setProdType] = useState(1);
  const [baskets, setBaskets] = useState([]);
  const [cart, setCart] = useState([]);
  const [loadMore, setLoadMore] = useState(false);
  const value = { cart, setCart };
  const data = {
    products,
    baskets,
    prodType,
    loadMore,
    loading,
    setProducts,
    setBaskets,
    setProdType,
    setLoadMore,
    setLoading,
  };

  //get products, and baskets
  const getData = useCallback(async () => {
    setLoading((prev) => true);
    try {
      const b = await Fire._getBaskets();
      const p = await Fire._getProducts();
      setProducts(p);
      setBaskets(b);
    } catch (error) {
      setType(2);
      setMessage(error.message);
      setVisible(true);
    } finally {
      setLoading((prev) => false);
    }
  }, [setType, setVisible, setMessage]);

  const _loadMoreProducts = useCallback(async () => {
    if (!loadMore) return;
    try {
      const p = await Fire._getMoreProducts();
      if (p.length > 0) setProducts((prev) => [...prev, ...p]);
    } catch (error) {
      setType(2);
      setMessage(error.message);
      setVisible(true);
    } finally {
      setLoadMore((prev) => false);
    }
  }, [loadMore, setType, setVisible, setMessage]);

  useEffect(() => {
    //get products, baskets, and ads
    getData();

    let unsubscribe = null;
    Fire._currentUser((user) => {
      if (!user) return;
      unsubscribe = Fire._getCart(user.uid, (items) => setCart(items || []));
    });
    return () => {
      unsubscribe?.();
      setProducts([]);
      setBaskets([]);
    };
  }, [getData]);

  useEffect(() => {
    _loadMoreProducts();
  }, [_loadMoreProducts, loadMore]);

  /* Set the width of the side navigation to 250px */
  const openNav = () => {
    document.getElementById(
      t("language") === "en" ? "menu" : "menu-en"
    ).style.width = "350px";
    document.getElementById(
      t("language") === "en" ? "menu" : "menu-en"
    ).style.paddingInline = "10px";
  };

  return (
    <>
      <Col lg={6} className="main" style={{ backgroundColor: "#ffffff" }}>
        <div className="drawer-container">
          <FontAwesomeIcon
            icon={faBars}
            size="2x"
            color="#000"
            className="m-2 ms-3 hoverable drawerButton"
            onClick={openNav}
          />
        </div>
        <div className="flex-fill screens">
          <DataContext.Provider value={data}>
            <CartContext.Provider value={value}>
              <Route exact path="/" component={Home} />
              <Route exact path="/product/details/:id" component={Product} />
              <Route exact path="/basket/details/:id" component={Basket} />
              <Route exact path="/checkout/" component={Checkout} />
            </CartContext.Provider>
          </DataContext.Provider>
          <Route exact path="/orders/" component={Orders} />
          <Route exact path="/settings" component={Settings} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/terms" component={Terms} />
          <Route exact path="/reset" component={Reset} />
        </div>
      </Col>

      <Col lg={3} className="rightside">
        <CartContext.Provider value={value}>
          <RightSideBar />
        </CartContext.Provider>
      </Col>

      <div id={t("language") === "en" ? "menu" : "menu-en"}>
        <LeftSideBar />
        <hr className="text-muted" />
        <CartContext.Provider value={value}>
          <RightSideBar />
        </CartContext.Provider>
      </div>

      <Dialog
        visible={visible}
        onHide={() => setVisible(false)}
        message={message}
        type={type}
      />
    </>
  );
};

export default Routes;
